var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoInstagramVariant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7977 4.1515C11.2912 4.1515 11.6913 3.75141 11.6913 3.25787C11.6913 2.76434 11.2912 2.36426 10.7977 2.36426C10.3041 2.36426 9.90405 2.76434 9.90405 3.25787C9.90405 3.75141 10.3041 4.1515 10.7977 4.1515Z",
    fill: "#610099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35107 7.05586C3.35107 5.00976 5.00979 3.35107 7.05588 3.35107C9.10199 3.35107 10.7607 5.00976 10.7607 7.05586C10.7607 9.10198 9.10199 10.7607 7.05588 10.7607C5.00979 10.7607 3.35107 9.10198 3.35107 7.05586ZM7.05588 4.65426C5.72952 4.65426 4.65427 5.72949 4.65427 7.05586C4.65427 8.38218 5.72952 9.45742 7.05588 9.45742C8.3823 9.45742 9.45743 8.38218 9.45743 7.05586C9.45743 5.72949 8.3823 4.65426 7.05588 4.65426Z",
    fill: "#610099"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0399 1.3032C2.52845 1.3032 1.30319 2.52846 1.30319 4.0399V9.96011C1.30319 11.4715 2.52845 12.6969 4.0399 12.6969H10.0346C11.5461 12.6969 12.7713 11.4715 12.7713 9.96011V4.0399C12.7713 2.52846 11.5461 1.3032 10.0346 1.3032H4.0399ZM0 4.0399C0 1.80873 1.80873 0 4.0399 0H10.0346C12.2658 0 14.0746 1.80873 14.0746 4.0399V9.96011C14.0746 12.1913 12.2658 14 10.0346 14H4.0399C1.80873 14 0 12.1913 0 9.96011V4.0399Z",
    fill: "#610099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInstagramVariant);
export default __webpack_public_path__ + "static/media/logo-instagram-variant.d25b9587.svg";
export { ForwardRef as ReactComponent };